<script>
	import { onMount } from 'svelte';
	import Week from './Week.svelte';

	let params = (new URL(window.location)).searchParams;
	let query = params.get("birthday");
	let urlBirthday = !query || isNaN(new Date(query)) ? "1990-01-01" : query;

	let avgAge = 82;
	let birthday = new Date(urlBirthday);
	let today = new Date();
	let avgWeeks = Math.round(avgAge * 52.14);
	let weekMask = Array.from(new Array(avgWeeks));

	$: weeks = weekMask.map((_, weekIndex) => {
		const freshDate = new Date(birthday.getTime())
		freshDate.setDate(birthday.getDate() + (weekIndex * 7));
		return {
			firstDay: freshDate
		}
	});
	$: weeksLived = Math.round((today - birthday) * 1.65344e-9);

	const flatpickrOptions = {
		enableTime: false,
		onChange: (selectedDates, dateStr, instance) => {
			birthday = selectedDates[0];
		}
	}
</script>

<div class="container">
	<div class="sign-container">
		<span class="sign">
			{#if weeksLived > 0}
				You lived {weeksLived} of {avgWeeks} weeks*.
			{:else}
				Beep boop 🤖noop
			{/if}
		</span>
	</div>

	<div class="weeks-container">
		{#each weeks as week}
			<Week day={week.firstDay}/>
		{/each}
	</div>
	<span class="note">
		* given 81 years average life expectancy in Germany and your birthday {urlBirthday}
	</span>
</div>

<style>
	.container {
		max-width: 800px;
		margin: 0 auto;
	}

	.sign-container {
		display: flex;
		justify-content: center;
	}

	.sign {
		border: 1px solid #111;
		border-bottom-width: 3px;
		padding: 9px;
		transform: translateY(18px);
		background-color: white;
	}

	.weeks-container {
		display: flex;
		flex-wrap: wrap;
		padding: 32px;
		border: 1px solid #111;
		border-bottom-width: 3px;
	}

	.note {
		display: block;
		text-align: right;
		font-size: .6em;
		line-height: 2;
		margin-bottom: 50px;
	}
</style>
